var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.mainClasses,attrs:{"dir":_vm.direction}},[_c('v-content',[(_vm.isReady)?_c('router-view',{class:{"dialog-open": _vm.isDialogOpen}}):_vm._e(),(_vm.showLoader)?_c('IconsLoader',{staticClass:"app-loader",attrs:{"size":_vm.loaderSize}}):_vm._e()],1),_c("style",{tag:"component"},[_vm._v(_vm._s(_vm.brandingColors))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }